//#region Imports

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

//#endregion

//#region Interceptor

export function baseUrl(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const newReq = req.clone({
    url: `${environment.apiUrl}${req.url}`
  });

  return next(newReq);
}

//#endregion
